export function InsertTable (pEditor, pTable)
{
  function queryOpenInsertTableDialogEnabled (pButton, command)
  {
    return ((BEditor.browser.isIE) ? true : pEditor.queryBasicCommandEnabled(pButton, 'inserthtml'));
  }


  this.openInsertTableDialog = (pButton) =>
  {
    pEditor.pDialog = pButton.getDialog();
    var pDialogDropdowns = pButton.getAttribute('MultiDropdownLevel3');

    if (!pEditor.pDialog || !pDialogDropdowns)
      return false;

    pEditor.range.save();

    pEditor.pDialog.setReturnedParameters('pDialogDropdowns', pDialogDropdowns);
    pEditor.pDialog.setReturnedParameters('sCommand', null);
    pEditor.pDialog.setReturnedParameters('htmlContent', '');

    pEditor.pDialog.openWindow(function() { pEditor.pThis.execCommand(pButton, 'insertTable'); }, function() { pEditor.closeDialog(pEditor.pDialog); }, null, null, null, 529, 500);

    pEditor.afterOpenDialog();
  };


  function insertTable (pButton)
  {
    var tableHTML;
    var pParameters, currentRange;

    if (pEditor.pDialog)
    {
      pParameters = pEditor.pDialog.getReturnedParameters();

      if (pParameters)
      {
        tableHTML = pParameters.htmlContent;
      }

      pEditor.closeDialog();

      if (tableHTML.replace(/\s+/g, '') !== '')
      {
        currentRange = pEditor.range.getCurrent();

        if (currentRange)
        {
          pEditor.helpers.insertHTML(tableHTML);
          pEditor.helpers.fixers.setFixGeckoTables({isFix: true});
        }
      }
    }
  }


  this.queryOpenInsertTableDialogEnabled = queryOpenInsertTableDialogEnabled;
  this.insertTable = insertTable;
}